/**
 * Company Search — unknown-to-entity-spine (sealed state 3).
 *
 * lookup_company returned no resolved organization (status unresolved/excluded,
 * or resolved with no id). Personal RADAR tracking and the Company
 * Intelligence Brief remain available without inventing a BDSE relationship.
 * A name-only tracker is honest about awaiting governed identity resolution;
 * matching begins only after that resolution is established.
 */

import { IconSearch } from "./icons";
import { CompanyBrief } from "./CompanyBrief";
import { RadarTracker } from "./RadarTracker";

export function UnknownToSpine({ query }: { query: string }): JSX.Element {
  return (
    <div className="sxco-unknown">
      <span className="sxco-unknown-icon" aria-hidden="true">
        <IconSearch />
      </span>
      <h2 className="sxco-unknown-title">No existing relationship in BDSE</h2>
      <p className="sxco-unknown-sub">
        BDSE does not have a recorded relationship for “{query}” yet. You can still track the
        company in RADAR or generate a Company Intelligence Brief.
      </p>
      <div className="sxco-unknown-tools">
        <div className="sxco-unknown-scan">
          <RadarTracker key={query} organizationId={null} companyName={query} />
        </div>
        {/* Name-only generation is an existing backend contract. Keying on the
            query prevents a prior unresolved company's local handle from being
            displayed after a new search. */}
        <CompanyBrief key={query} organizationId={null} companyName={query} />
      </div>
    </div>
  );
}
